import React, { Fragment, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import CartList from "./CartList";
import useTokenCheck from "../../hooks/useTokenCheck";
import AuthContext from "../../context/auth/AuthContext";
import CartContext from "../../context/cart/CartContext";
import useEntityContext from "../../hooks/entity-context";
import Preloader from "./../layout/Preloader";
import UnregActionMenu from "../layout/UnregActionMenu";
import { DELETE_CART_ITEM } from "../../context/types";
import "./Cart.css";
import usePageTitle from "../../hooks/usePageTitle";

const Cart = (props) => {
  const authContext = useContext(AuthContext);
  const cartContext = useContext(CartContext);
  const { user, token } = authContext;
  const { loading, cart, loadItems, error } = cartContext;
  const [processing, updateEntity] = useEntityContext();

  const history = useHistory();

  const [mode, setMode] = useState("Edit");

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Cart",
  });

  useEffect(() => {
    console.log("cart", cart);
    if (!error) {
      loadItems({}, token);
    }
    //eslint-disable-next-line
  }, []);
  const { hasTokenExpired } = useTokenCheck();
  const addMoreCard = () => {
    console.log("Add More");
    history.push("/unreg-recharge-card");
  };
  const onSubmit = async () => {
    await hasTokenExpired();
    if (user.sponsor) {
      setMode("View");
    } else {
      history.push("/billing");
    }
  };
  const onSubmitOrder = () => {
    history.push("/confirm-order");
  };

  const handleDelete = async (item) => {
    console.log("Delete:", item);
    await updateEntity(item, DELETE_CART_ITEM);
    if (!error) {
      loadItems({}, token);
    }
  };

  // useEffect(() => {
  //   clearAlerts();
  //   //eslint-disable-next-line
  // }, []);

  return (
    <Fragment>
      {(loading || processing) && <Preloader />}
      <UnregActionMenu />
      <div
        className="privateView"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <h1 className="privateView__pageTitle ">
          {mode === "Edit" ? "Cart" : "REVIEW AND ORDER"}
        </h1>
        <div className="cartContainer">
          {cart && cart.cartItems.length > 0 ? (
            <Fragment>
              <CartList
                cart={cart}
                enableAction={true}
                onDelete={handleDelete}
              />
              {mode === "Edit" ? (
                <div className="cartContainer__action" aria-live="assertive">
                  <input
                    aria-label="ADD MORE TO CART button"
                    type="button"
                    value="ADD MORE TO CART"
                    className="btn btn-block btn-primary cartContainer__action__button"
                    onClick={addMoreCard}
                  />
                  <input
                    aria-label="CHECKOUT button"
                    type="submit"
                    value="CHECKOUT"
                    className="btn btn-block btn-primary"
                    onClick={onSubmit}
                  />
                </div>
              ) : (
                <div className="cartContainer__action">
                  <input
                    aria-label="SUBMIT ORDER button"
                    type="submit"
                    value="SUBMIT ORDER"
                    className="btn btn-block btn-primary"
                    onClick={onSubmitOrder}
                  />
                </div>
              )}
            </Fragment>
          ) : (
            <Fragment>
              {!loading && (
                <div className="patronHome__pageTitle__desc">
                  Your Cart is Empty
                </div>
              )}
            </Fragment>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default Cart;
